import {
  UnderlinedTabListProps,
  UnderlinedTabsList,
} from './UnderlinedTabsList';

export type UnderlinedNavTabsProps = UnderlinedTabListProps;

export const UnderlinedNavTabs = UnderlinedTabsList;
